// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1lBFa","signatureButtonsRight":"ModalSign_signatureButtonsRight__3R_km"};